import { Grid } from '@mui/material';
import CardWrapper from 'components/Financial/CardWrapper';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import { useLoadDataByLocation } from 'hooks/useLoadDataByLocation';
import { totalValue } from 'pages/purchase/helpers';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import RemittanceService from 'services/RemittanceService';
import InputGroup from './InputGroup';
import { remittanceSchema } from './schema';

function Remittance({ updateTotalPrice, callback = () => {} }, ref) {
  const [species, setSpecies] = useState([]);
  const formik = useFormik({
    initialValues: {
      lots: [
        {
          name: '',
          specie: null,
          size: '',
          old: '',
          price: '',
        },
      ],
    },
    validationSchema: remittanceSchema,
  });

  const getValueTotal = totalValue(formik.values.lots, 'price');

  useEffect(() => {
    async function loadSpecies() {
      try {
        let response = await RemittanceService.speciesList();
        if (response.length === 0) {
          await Promise.all([
            RemittanceService.create({
              name: 'Peixe',
              category: 'Peixe',
            }),
            RemittanceService.create({
              name: 'Camarão',
              category: 'Camarão',
            }),
          ]);

          response = await RemittanceService.speciesList();
        }

        setSpecies(response);
      } catch (e) {
        throw new Error();
      }
    }
    loadSpecies();
  }, []);

  useEffect(() => {
    if (getValueTotal > 0) {
      updateTotalPrice(getValueTotal);
    }
  }, [getValueTotal, updateTotalPrice]);

  const hasRemittance = formik.values.lots && formik.values.lots.length > 0;

  function setData(data) {
    if (!data) return;

    const { lots } = data;

    formik.setValues({
      lots,
    });
  }

  useLoadDataByLocation({ setData });

  const handleSubmit = async () => {
    try {
      await formik.submitForm();
    } catch (e) {}
  };

  useEffect(() => {
    callback({ isValid: formik.isValid, values: formik.values });
  }, [callback, formik.isValid, formik.values]);

  // Permite que o componente pai chame o método handleSubmit
  useImperativeHandle(ref, () => ({
    handleSubmit,
  }));

  return (
    <FormikProvider value={formik}>
      <CardWrapper title="Identificação">
        <FieldArray name="lots">
          {({ remove, push }) => (
            <Grid item container rowGap={2}>
              {hasRemittance &&
                formik.values.lots.map((_, index) => (
                  <InputGroup
                    key={index}
                    index={index}
                    species={species}
                    onRemove={() => remove(index)}
                    onAdd={() =>
                      push({
                        name: '',
                        specie: null,
                        size: '',
                        old: '',
                        price: '',
                      })
                    }
                  />
                ))}
            </Grid>
          )}
        </FieldArray>
      </CardWrapper>
    </FormikProvider>
  );
}

export default forwardRef(Remittance);
